module.exports = __webpack_public_path__ + "media/footer/LinkedIn-33c6b1bf.png";